import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import img1 from "../../assets/Images/Home/pexels-seven11nash-380769.jpg";
import img2 from "../../assets/Images/Home/Website_HomePageNP2.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function NewsAndPress() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const isMobile = useIsMobile();

  const Panel = ({ image, title, description, link, index }) => (
    <div
      className="image-container"
      style={{
        minHeight: isMobile ? "300px" : "500px",
      }}
      onMouseEnter={() => setHoveredItem(index)}
      onMouseLeave={() => setHoveredItem(null)}
    >
      <img
        src={image}
        alt={`news-${index}`}
        className="image-cover-full-responsive"
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor:
            hoveredItem === index ? "rgba(0, 0, 0, 0.3)" : "rgba(0, 0, 0, 0.5)",
          transition: "all 0.5s ease",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "10%",
          right: "10%",
          transform: `translateY(${hoveredItem === index ? "-60%" : "-50%"})`,
          transition: "transform 0.5s ease",
          color: "white",
          textAlign: "center",
          fontFamily: "BodoniModa_18pt",
        }}
      >
        <div
          style={{
            transition: "all 0.5s ease",
            opacity: hoveredItem === index ? 1 : 0.8,
            transform:
              hoveredItem === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <h4 className="heading-sm m-0">{title}</h4>
        </div>
        <div
          style={{
            marginTop: "10px",
            transition: "all 0.5s ease",
            opacity: hoveredItem === index ? 1 : 0.8,
            transform:
              hoveredItem === index ? "translateY(-10px)" : "translateY(0)",
          }}
        >
          <p className="body-md">{description}</p>
        </div>

        <Button
          className="rounded-0 text-uppercase"
          variant="outline-light"
          style={{
            fontSize: isMobile ? "18px" : "28px",
            fontFamily: "BodoniModa_18pt",
            width: isMobile ? "100%" : "80%",
            transition: "all 0.5s ease",
            transform:
              hoveredItem === index ? "translateY(-10px)" : "translateY(0)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "white";
            e.target.style.color = "black";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
          }}
          onClick={() => window.open(link, "_blank")}
        >
          Read More
        </Button>
      </div>
    </div>
  );

  return (
    <Container fluid className="p-0">
      {/* Title Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          />
        )}
        <div
          className="border-bottom-black border-right-black"
          style={{
            width: isMobile ? "50%" : "30%",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0 text-center">NEWS.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "30%",
            }}
          />
        )}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "50%" : "30%",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 40px",
            }}
          >
            <h3 className="heading-sm m-0 text-center">PRESS.</h3>
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          />
        )}
      </div>

      {/* Panels Row */}
      <div
        className="d-flex justify-content-center"
        style={{ flexDirection: isMobile ? "column" : "row" }}
      >
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          />
        )}
        <div
          className={`border-bottom-black ${!isMobile && "border-right-black"}`}
          style={{
            width: isMobile ? "100%" : "45%",
            padding: 0,
          }}
        >
          <Panel
            index={1}
            image={img1}
            title="COLORS TO USE IN OFFICE TO BOOST YOUR MOOD"
            description="In an interview with HT Lifestyle, Kritika Goswamy Malik, Co-Founder of HomeGaatha, shared..."
            link="https://www.hindustantimes.com/lifestyle/art-culture/interior-decor-design-tips-colours-to-use-in-office-or-your-work-space-to-boost-mood-and-productivity-101742912958550.html"
          />
        </div>
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "45%",
            padding: 0,
          }}
        >
          <Panel
            index={2}
            image={img2}
            title="THE DOPAMINE DÉCOR MOVEMENT"
            description="Dopamine Décor is more than just a design trend; it’s the art of creating spaces that uplift moods..."
            link="https://media.biltrax.com/dopamine-decor-the-psychology-of-joyful-spaces/"
          />
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          />
        )}
      </div>

      {/* Hidden Duplicate Titles for layout symmetry */}
      {!isMobile && (
        <div className="d-flex justify-content-center">
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          />
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "15%",
            }}
          >
            <h2
              className="m-0 p-4 text-center"
              style={{
                fontSize: "100px",
                fontFamily: "BodoniModa_18pt",
                visibility: "hidden",
              }}
            >
              NEWS
            </h2>
          </div>
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "60%",
            }}
          />
          <div className="border-bottom-black" style={{ width: "15%" }}>
            <h2
              className="m-0 p-4 text-center"
              style={{
                fontSize: "100px",
                fontFamily: "BodoniModa_18pt",
                visibility: "hidden",
              }}
            >
              PRESS
            </h2>
          </div>
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          />
        </div>
      )}
    </Container>
  );
}
